// Module
var code = "<div class=\"embed-youtube embed-iframe\"> <div class=\"iframe\"> <iframe width=\"{{width}}\" height=\"{{height}}\" src=\"{{embed}}\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> </div> {{#caption}} <p class=\"caption\">{{caption}}</p> {{/caption}} </div> ";
// Exports
export default code;